import React from 'react';
import { motion } from 'framer-motion';
import { FiTruck, FiNavigation, FiPackage, FiSend, FiInbox, FiTool, FiGlobe } from 'react-icons/fi';

const servicesData = [
  {
    title: "Pengiriman Darat",
    desc: "Distribusi logistik lintas pulau dan provinsi yang menjangkau seluruh pelosok negeri dengan jadwal pasti dan armada prima.",
    icon: FiTruck
  },
  {
    title: "Pengiriman Laut",
    desc: "Solusi efisien kargo volume besar (FCL/LCL). Bermitra dengan operator pelayaran terkemuka untuk efisiensi dan keamanan.",
    icon: FiNavigation
  },
  {
    title: "City Courier",
    desc: "Pengiriman cepat dalam kota untuk dokumen dan paket kecil. Menjaga konektivitas bisnis tanpa hambatan trafik kota.",
    icon: FiPackage
  },
  {
    title: "Pengiriman Udara",
    desc: "Pilihan tercepat untuk barang sensitif waktu. Layanan door-to-door mencakup bandara utama Indonesia & mancanegara.",
    icon: FiSend
  },
  {
    title: "Trucking",
    desc: "Penyediaan unit truk (CDD, Fuso, Wingbox, Trailer) siap mendukung suplai logistik perusahaan dan proyek konstruksi.",
    icon: FiInbox
  },
  {
    title: "Towing",
    desc: "Layanan derek & pengiriman kendaraan bermotor profesional. Armada khusus menjamin keamanan kendaraan personal/perusahaan.",
    icon: FiTool
  },
  {
    title: "International Shipping",
    desc: "Ekspedisi global ekspor-impor. Menangani dokumen, bea cukai (Customs Clearance), dan logistik lintas negara.",
    icon: FiGlobe
  }
];

const Services = () => {
  return (
    <section id="services" className="py-24 bg-white relative">
      <div className="container mx-auto px-4 md:px-8">
        
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-1 bg-brand-red"></div>
            <h4 className="text-brand-red font-bold uppercase tracking-widest text-sm">Layanan Kami</h4>
            <div className="w-8 h-1 bg-brand-red"></div>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-brand-black">Solusi Logistik Menyeluruh</h2>
          <p className="text-gray-600 text-lg">Kami menyediakan berbagai layanan yang disesuaikan untuk memenuhi setiap kebutuhan rantai pasok bisnis Anda.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {servicesData.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group bg-white border border-gray-100 rounded-2xl p-8 hover:shadow-premium-hover transition-all duration-300 hover:-translate-y-2 hover:border-brand-red/30 flex flex-col h-full"
            >
              <div className="w-16 h-16 rounded-xl bg-gray-50 flex items-center justify-center mb-6 group-hover:bg-brand-red transition-colors duration-300 shadow-sm">
                <service.icon className="text-brand-black group-hover:text-white text-3xl transition-colors" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-brand-black">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm flex-grow">{service.desc}</p>
            </motion.div>
          ))}
          
          {/* CTA Card to fill the 8th slot in a 4-col grid */}
          <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.7 }}
              className="bg-brand-black rounded-2xl p-8 flex flex-col justify-center items-center text-center h-full relative overflow-hidden"
            >
              <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?q=80&w=2070&auto=format&fit=crop')] opacity-20 bg-cover bg-center"></div>
              <div className="relative z-10">
                <h3 className="text-2xl font-bold mb-4 text-white">Butuh Layanan Khusus?</h3>
                <p className="text-gray-300 mb-6 text-sm">Konsultasikan kebutuhan logistik spesifik Anda dengan tim ahli kami.</p>
                <a href="https://wa.me/6282315268197" target="_blank" rel="noreferrer" className="inline-block bg-brand-red text-white py-2 px-6 rounded-full font-semibold hover:bg-white hover:text-brand-red transition-colors">
                  Chat Sekarang
                </a>
              </div>
            </motion.div>
        </div>

      </div>
    </section>
  );
};

export default Services;